import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import HeaderM from "../../Invs/maintaince/A4/HeaderM";
import LoadingPage from "../../../services/LoadingPage";
import BodyInv from "./A4/BodyInv";
import FooterD from "./A4/FooterD";
import UnderHeader from "./A4/UnderHeader"
import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import { sto } from "../../../Context/InshData";
import RevInvMain from "./RevInvMain";




function RevInvCon(props) {
    const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
    const [found, setFound] = useState({});
    const [sta, setSta] = useState({});
    const [inv, setInv] = useState({});
    const [loading, setLoading] = useState(true);
    const [chunks, setChunks] = useState([]);
    const [data, setData] = useState([]);

    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const mergColumn = (symbol,nameEN) => {
        if (nameEN !=null && nameEN !=""){
          return `${symbol} \n ${nameEN}`
        }else{
          return `${symbol}`
        }
    };
    let count_id = 0;
    const getInfo = async () => {
        // alert('getInfo')
        const tb = {
            GetFoundation: true,
            Rpt_Inv: true,
            wait: true,
            parms: {
                lprocid: locInv.proc_id,
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
                sProcTypeInvProc: locInv.ProcTypeInvProc,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setSta({ info: res.data.RptInv, tot: res.data.infoBill });
                console.log("res.data.RptInv");
                const data2 = res.data.RptInv.map((row, i) => {
                    return {
                        ...row,
                        no: i + 1,
                        notesall:mergColumn(row.symbol,row.notes_details),
                    };
                });
                setData(data2);
                if (premiApp.billTemplate === 1 || premiApp.billTemplate === 20) {
                    setChunks(_.chunk(data2, 16));
                } else if (premiApp.billTemplate === 17) {
                    setChunks(_.chunk(data2, 8));
                } else if (premiApp.billTemplate === 24) {
                    setChunks(_.chunk(data2, 3));
                }
                else {
                    setChunks(_.chunk(data2, 12));
                }
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };
    const getInv = async () => {
        axios
            .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
            .then((res) => {
                console.log("the inve for fatoora", res.data);
                setInv(res.data);
            })
            .catch((error) => { });
    };

    const maxHieght = 400;

    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            await getInv();
            setLoading(false);
        }, 0);
    }, []);



    if (!found || !sta || loading) return <LoadingPage />;


    return (
        <div>
            <RevInvMain
                {...{
                    locInv, found, sta, inv,data
                }}
            />
        </div>
    );
}
export default RevInvCon;
